// extracted by mini-css-extract-plugin
module.exports = {"telegram-login-widget":"index_telegram-login-widget__iovWc"};